document.addEventListener('DOMContentLoaded', () => {
    const allBundleSteps = document.querySelectorAll('.bundle-step');
    const LAST_STEP_NUMBER = Math.max(
        ...Array.from(allBundleSteps).map(s => parseInt(s.dataset.step))
    );

    const selections = {};
    const steps = document.querySelectorAll('.bundle-step');
    steps.forEach(step => selections[step.dataset.step] = 0);

    document.querySelectorAll('.bundle-product').forEach(card => {
        const step = card.dataset.step;
        const addBtn = card.querySelector('.add-box');
        const form = document.querySelector('form.product-bundle-forms');

        const stepEl = document.querySelector(`.bundle-step[data-step="${step}"]`);
        const limit = parseInt(stepEl.dataset.limit);

        // ADD PRODUCT (single quantity)
        addBtn.addEventListener('click', () => {
            if (selections[step] >= limit) return;

            selections[step] += 1;
            addBtn.classList.add('hidden');

            updateButtons(step, limit);
            checkStep(step);
            showStickyBar();
            updateBundleProperties(form, card, 1, step);
        });
    });

    /* ---------------- BUTTON STATE ---------------- */

    function updateButtons(step, limit) {
        const disabled = selections[step] >= limit;

        document
            .querySelectorAll(`.bundle-product[data-step="${step}"] .add-box`)
            .forEach(btn => btn.classList.toggle('disabled', disabled));

        updateAddToCartButton();
    }

    function updateAddToCartButton() {
        let allSelected = true;

        document.querySelectorAll('.bundle-step').forEach(step => {
            if (step.classList.contains('last-step')) return;

            const stepNum = step.dataset.step;
            const stepLimit = parseInt(step.dataset.limit);

            if (selections[stepNum] < stepLimit) {
                allSelected = false;
            }
        });

        const addBtn = document.querySelector('.bundle-add-to-cart');
        const mainForm = document.getElementById('bundle-add-to-cart');

        if (addBtn && mainForm) {
            addBtn.disabled = !allSelected;
            addBtn.style.display = 'flex';
            mainForm.style.display = 'block';
        }
    }

    /* ---------------- BUNDLE PROPERTIES ---------------- */

    function updateBundleProperties(form, product, quantity) {
        if (!form || !product) return;

        let input = form.querySelector(
            `input[data-bundle-id="${product.dataset.id}"]`
        );

        if (quantity > 0) {
            if (!input) {
                // input = document.createElement('input');
                // input.type = 'hidden';
                // input.dataset.bundleId = product.dataset.id;
                // form.appendChild(input);
                const newInput = document.createElement('input');
                newInput.type = 'hidden';
                newInput.name = `properties[Item${form.querySelectorAll('input[name^="properties[Item"]').length + 1}]`;
                newInput.dataset.bundleId = product.dataset.id;
                newInput.value = `${product.dataset.title}__${product.dataset.price}[sku:${product.dataset.sku}] x ${quantity}`;
                form.appendChild(newInput);

                const newInput1 = document.createElement('input');
                newInput1.type = 'hidden';
                newInput1.name = `properties[_Item_price${form.querySelectorAll('input[name^="properties[_Item_price"]').length + 1}]`;
                newInput1.dataset.bundleId = product.dataset.id;
                newInput1.value = `${product.dataset.price}`;
                form.appendChild(newInput1);
            }
            else {
                input.value = `${product.dataset.title}[sku:${product.dataset.sku}] x ${quantity}`;
            }
            //input.value = `${product.dataset.title} x 1`;
        } else {
            if (input) input.remove();
        }

        // Reindex Item1, Item2, Item3...
        form.querySelectorAll('input[data-bundle-id]').forEach((inp, i) => {
            inp.name = `properties[Item${i + 1}]`;
        });

        syncStickyItem(product, quantity);
    }

    /* ---------------- STICKY SUMMARY ---------------- */

    function syncStickyItem(product, quantity) {
        const stickyWrap = document.querySelector('.sticky-products');
        if (!stickyWrap) return;

        const bundleId = product.dataset.id;
        const item = stickyWrap.querySelector(
            `.sticky-item[data-bundle-id="${bundleId}"]`
        );

        if (quantity <= 0) {
            if (item) item.remove();
            return;
        }

        if (!item) {
            const newItem = document.createElement('div');
            newItem.className = 'sticky-item';
            newItem.dataset.bundleId = bundleId;
            newItem.innerHTML = `
                <img src="${product.dataset.image}" alt="">
                <button type="button" class="bundle-remove">✕</button>
            `;
            stickyWrap.appendChild(newItem);
        }
    }

    /* ---------------- REMOVE FROM STICKY ---------------- */

    document.addEventListener('click', (e) => {
        const removeBtn = e.target.closest('.bundle-remove');
        if (!removeBtn) return;

        const stickyItem = removeBtn.closest('.sticky-item');
        if (!stickyItem) return;

        const bundleId = stickyItem.dataset.bundleId;

        const product = document.querySelector(
            `.bundle-product[data-id="${bundleId}"]`
        );
        if (!product) return;

        const step = parseInt(product.dataset.step);
        const stepEl = document.querySelector(`.bundle-step[data-step="${step}"]`);
        if (!stepEl) return;

        const addBtn = product.querySelector('.add-box');
        const form = document.querySelector('.product-bundle-forms');

        /* ===============================
        DATA UPDATE
        =============================== */
        selections[step] = Math.max(0, selections[step] - 1);
        updateBundleProperties(form, product, 0);
        stickyItem.remove();

        /* ===============================
        🔓 BUTTON HARD RESET (FIX)
        =============================== */
        if (addBtn) {
            addBtn.classList.remove('hidden', 'disabled');
            addBtn.removeAttribute('disabled');
            addBtn.style.pointerEvents = 'auto';
            addBtn.textContent = addBtn.dataset.originalText || 'Add to box';
        }

        /* ===============================
        STEP STATE RESET
        =============================== */
        unlockSteps(step);

        document.querySelectorAll('.bundle-step').forEach(s => {
            s.classList.remove('active');
            s.style.display = 'none';
        });

        stepEl.classList.remove('completed');
        stepEl.classList.add('active');
        stepEl.style.display = 'block';

        // hide next steps
        document.querySelectorAll('.bundle-step').forEach(s => {
            const sNum = parseInt(s.dataset.step);
            if (sNum > step) {
                s.classList.remove('active', 'completed');
                s.style.display = 'none';
            }
        });

        /* ===============================
        RE-CHECK LOGIC
        =============================== */
        checkStep(step);
        updateButtons(step, parseInt(stepEl.dataset.limit));
        updateAddToCartButton();

        stepEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });



    /* ---------------- STEP HANDLING ---------------- */
    function lockPreviousSteps(currentStepNum) {
        document.querySelectorAll('.bundle-product').forEach(product => {
            const productStep = parseInt(product.dataset.step);
            if (productStep < currentStepNum) {
                const addBtn = product.querySelector('.add-box');
                if (addBtn) {
                    addBtn.classList.add('disabled');
                    addBtn.style.pointerEvents = 'none';
                }
            }
        });

        document.querySelectorAll('.bundle-step').forEach(step => {
            const stepNum = parseInt(step.dataset.step);
            if (stepNum < currentStepNum && !step.classList.contains('last-step')) {
                step.style.display = 'none';
            }
        });
    }


    function checkStep(step) {
        const allSteps = document.querySelectorAll('.bundle-step');
        const allIndicators = document.querySelectorAll('.bundle-step-indicator');

        const currentStep = document.querySelector(`.bundle-step[data-step="${step}"]`);
        if (!currentStep) return;

        const stepLimit = parseInt(currentStep.dataset.limit);
        const stepNum = parseInt(step);
        const isLastStep = stepNum === LAST_STEP_NUMBER;

        /* ===============================
        STEP COMPLETION (ONLY ON LIMIT)
        =============================== */
        if (selections[step] >= stepLimit) {

            currentStep.classList.add('completed');

            // 🔒 lock previous steps
            lockPreviousSteps(stepNum);

            // 👉 activate next step ONLY if not last
            if (!isLastStep) {
                const nextStepNum = stepNum + 1;
                const nextStep = document.querySelector(
                    `.bundle-step[data-step="${nextStepNum}"]`
                );

                if (nextStep) {
                    currentStep.classList.remove('active');
                    nextStep.classList.add('active');
                    nextStep.style.display = 'block';
                    nextStep.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }
        }

        /* ===============================
        STEP INDICATOR STATE (FINAL)
        =============================== */
        allIndicators.forEach(indicator => {
            const indStepNum = parseInt(indicator.dataset.step);

            //indicator.classList.remove('active', 'completed');

            // Previous steps
            if (indStepNum < stepNum) {
                indicator.classList.add('completed');
            }

            // Current step (ALWAYS active)
            if (indStepNum === stepNum) {
                indicator.classList.add('completed', 'active');
            }

            // Next step indicator (ONLY when moving forward & not last)
            if (
                !isLastStep &&
                indStepNum === stepNum + 1 &&
                selections[step] >= stepLimit
            ) {
                indicator.classList.add('active');
            }
        });

        /* ===============================
        VISIBILITY RULE (STRICT)
        =============================== */
        allSteps.forEach(stepEl => {
            if (stepEl.classList.contains('active')) {
                stepEl.style.display = 'block';
            } else {
                stepEl.style.display = 'none';
            }
        });
    }

    /* ---------------- STEP INDICATOR CLICK ---------------- */

    document.querySelectorAll('.bundle-step-indicator').forEach(indicator => {
        indicator.addEventListener('click', () => {
            const stepNum = parseInt(indicator.dataset.step);

            // 🚫 BLOCK skipping steps
            if (!canNavigateToStep(stepNum)) {
                return;
            }

            document.querySelectorAll('.bundle-step').forEach(s => {
                s.classList.remove('active');
                if (!s.classList.contains('last-step')) {
                    s.style.display = 'none';
                }
            });

            const stepEl = document.querySelector(
                `.bundle-step[data-step="${stepNum}"]`
            );

            if (stepEl) {
                stepEl.classList.add('active');
                stepEl.style.display = 'block';
                stepEl.scrollIntoView({ behavior: 'smooth' });
            }

            document
                .querySelectorAll('.bundle-step-indicator')
                .forEach(i => i.classList.remove('active'));

            indicator.classList.add('active');
        });
    });

    /* ---------------- RESET AFTER ADD TO CART ---------------- */

    document.addEventListener('submit', function (e) {
        const form = e.target.closest('.product-bundle-forms');
        if (!form) return;

        setTimeout(() => {
            resetBundleSelection();
        }, 2000);
    });

    function resetBundleSelection() {
        Object.keys(selections).forEach(step => selections[step] = 0);

        document.querySelectorAll('.bundle-product').forEach(product => {
            const addBox = product.querySelector('.add-box');
            if (addBox) addBox.classList.remove('hidden', 'disabled');
        });

        document.querySelectorAll('.bundle-step').forEach((step, i) => {
            step.classList.remove('active', 'completed');
            if (i === 0 || step.classList.contains('last-step')) {
                step.style.display = 'block';
            } else {
                step.style.display = 'none';
            }
        });

        document.querySelectorAll('.bundle-step-indicator').forEach((ind, i) => {
            ind.classList.remove('active', 'completed');
            if (i === 0) ind.classList.add('active');
        });

        document.querySelectorAll('.sticky-item').forEach(item => item.remove());

        const form = document.querySelector('.product-bundle-forms');
        if (form) {
            form.querySelectorAll('input[data-bundle-id]').forEach(i => i.remove());
        }

        const addBtn = document.getElementById('bundle-add-to-cart');
        if (addBtn) {
            addBtn.disabled = true;
            addBtn.style.display = 'none';
        }
    }

    function showStickyBar() {
        const sticky = document.getElementById('bundle-sticky');
        if (!sticky) return;

        sticky.classList.remove('disabled');
        sticky.style.display = 'block';
    }

    function unlockSteps(fromStep) {
        document.querySelectorAll('.bundle-product').forEach(product => {
            const productStep = parseInt(product.dataset.step);

            if (productStep <= fromStep) {
                const addBtn = product.querySelector('.add-box');
                if (addBtn) {
                    addBtn.classList.remove('disabled');
                    addBtn.removeAttribute('disabled');
                    addBtn.style.pointerEvents = 'auto';
                }
            }
        });
    }

    function canNavigateToStep(targetStep) {
        let allowed = true;

        document.querySelectorAll('.bundle-step').forEach(step => {
            const stepNum = parseInt(step.dataset.step);
            const limit = parseInt(step.dataset.limit);

            if (stepNum < targetStep && selections[stepNum] < limit) {
                allowed = false;
            }
        });

        return allowed;
    }
});

